<template>
    <popup-overlay>
        <popup-wrapper>
            <button class="modal-popup__close" :aria-lable="$t('POPUP_CLOSE')" @click.prevent="close">
            </button>

            <div class="cz2__modal-popup__header text-base lg:text-2xl lg:tracking-loose">
                {{title}}
            </div>

            <div class="cz2__modal-popup__body-copy">
                {{description}}
            </div>

            <button class="cz2__modal-popup__button-cancel cz2__modal-popup__group-button" @click.prevent="close">
                {{action}}
            </button>
        </popup-wrapper>
    </popup-overlay>
</template>

<script>
    import PopupOverlay from './PopupOverlay.vue';
    import PopupWrapper from './PopupWrapper.vue';

    export default {
        components: {
            PopupOverlay,
            PopupWrapper,
        },
        computed: {
            title() {
                return this.$store.state.showGenericNotify.title;
            },
            description() {
                return this.$store.state.showGenericNotify.description;
            },
            action() {
                return this.$store.state.showGenericNotify.action;
            },
        },
        methods: {
            close() {
                this.$store.dispatch('showGenericNotify', null);
            },
        },
    };
</script>
